import { render, staticRenderFns } from "./dietdurationdetails.vue?vue&type=template&id=39409975&"
import script from "./dietdurationdetails.vue?vue&type=script&lang=js&"
export * from "./dietdurationdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports